import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

export const variantsPlugin: CorePlugin = createPluginFromSingleComponentPlugin({
    name: 'VariantsPlugin',
    pack,
    unpack
})
